/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchSubRuleFormValidationData
 */
export interface SearchSubRuleFormValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SearchSubRuleFormValidationData
     */
    description?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SearchSubRuleFormValidationData
     */
    maxPriceSolutions?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SearchSubRuleFormValidationData
     */
    maxPricePoints?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SearchSubRuleFormValidationData
     */
    carriers?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SearchSubRuleFormValidationData
     */
    fareTypes?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SearchSubRuleFormValidationData
     */
    accountCodes?: ValidationMessage;
}

export function SearchSubRuleFormValidationDataFromJSON(json: any): SearchSubRuleFormValidationData {
    return SearchSubRuleFormValidationDataFromJSONTyped(json, false);
}

export function SearchSubRuleFormValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchSubRuleFormValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : ValidationMessageFromJSON(json['description']),
        'maxPriceSolutions': !exists(json, 'maxPriceSolutions') ? undefined : ValidationMessageFromJSON(json['maxPriceSolutions']),
        'maxPricePoints': !exists(json, 'maxPricePoints') ? undefined : ValidationMessageFromJSON(json['maxPricePoints']),
        'carriers': !exists(json, 'carriers') ? undefined : ValidationMessageFromJSON(json['carriers']),
        'fareTypes': !exists(json, 'fareTypes') ? undefined : ValidationMessageFromJSON(json['fareTypes']),
        'accountCodes': !exists(json, 'accountCodes') ? undefined : ValidationMessageFromJSON(json['accountCodes']),
    };
}

export function SearchSubRuleFormValidationDataToJSON(value?: SearchSubRuleFormValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': ValidationMessageToJSON(value.description),
        'maxPriceSolutions': ValidationMessageToJSON(value.maxPriceSolutions),
        'maxPricePoints': ValidationMessageToJSON(value.maxPricePoints),
        'carriers': ValidationMessageToJSON(value.carriers),
        'fareTypes': ValidationMessageToJSON(value.fareTypes),
        'accountCodes': ValidationMessageToJSON(value.accountCodes),
    };
}


